import { getActivityTypes } from 'lib/selectors/getActivityTypes';
import _get from 'lodash/get';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useLookupActivityTypeName = () => {
  const activityTypes = useSelector(getActivityTypes);

  return useCallback(
    (activityTypeRef) => {
      const activityType = activityTypes.find((type) => {
        return type.activityTypeRef === activityTypeRef;
      });
      return _get(activityType, 'name', 'Unknown Activity');
    },
    [activityTypes]
  );
};

export default useLookupActivityTypeName;
